import { render } from "./PrintOptions.vue?vue&type=template&id=56f88dd4&scoped=true&ts=true"
import script from "./PrintOptions.vue?vue&type=script&lang=ts"
export * from "./PrintOptions.vue?vue&type=script&lang=ts"

import "./PrintOptions.vue?vue&type=style&index=0&id=56f88dd4&scoped=true&lang=css"

import exportComponent from "/home3/sli/web/public/resources/editorvue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56f88dd4"]])

export default __exports__